import { useMemo } from 'react';

import { BootstrapVerticalColumnTable } from '@components/Table/Table';

export const PlanRemarksTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Remarks',
        accessor: 'remarks',
        className: 'col-md-2',
      },
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'col-md-10' })}
      hideHeader
    />
  );
};
export const PlanOutboundRemarksTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Outbound remarks',
        accessor: 'outbound_remark',
        className: 'col-md-2',
      },
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({
        responsive: true,
        bordered: true,
        className: 'normalFontSize',
      })}
      valueProps={() => ({ className: 'col-md-10' })}
      hideHeader
    />
  );
};
